export default {
    group: (state) => {
        return state.group
    },
    getGroupModule: (state, getters) => (module) => {
      return getters.group.groupModule[module]
    },
    groupSetting: (state, getters) => {
        return getters.getGroupModule('setting')
    },
    groupMsg: (state, getters) => {
        return getters.getGroupModule('msg')
    }
}